import React from 'react';
import YouTube from 'react-youtube';

export const getPlayerSizingFactor = (): number => {
  if (window.innerWidth < 480) return 0.63;
  if (window.innerWidth < 768) return 0.78;
  return 1;
};

const YouTubePlayer: React.FC<{ width?: number; height: number; videoId: string }> = ({
  width,
  height,
  videoId
}): React.ReactElement => {
  const resizingFactor = getPlayerSizingFactor();

  return (
    <YouTube
      opts={{
        width: width ? `${width * resizingFactor}` : '100%',
        height: `${height * resizingFactor}`
      }}
      videoId={videoId}
    />
  );
};

export default YouTubePlayer;
